<div class="chip" (click)="remove()">
  <div class="flex">
    <span class="label">{{ (chip.translateKey + 'form.label.' + chip.label)| translate }}: </span>
    <span class="value">
      @if (chip.valueType !== type.BOOLEAN) {
        {{ chip.value | translate }}
      } @else {
        {{ (chip.translateKey + 'label' + chip.value) | translate }}
      }
    </span>
    <span><i class="fas fa-times"></i></span>
  </div>
</div>
